/*
 * Copyright 2015, Avaya Inc
 *
 */

/**
 *
 *  The avayaWebRTC Java Script Library provides a set of java script APIs for implementing a WebRTC application.
 *
 *  @module AvayaWebRTC
 **/
var internals = require('./avayawebrtc-client-internals.js');
var webrtcDetectedBrowser = require('./avayawebrtc-client-internals.js').webrtcDetectedBrowser;
var webrtcDetectedVersion = require('./avayawebrtc-client-internals.js').webrtcDetectedVersion;

var FIREFOXBROWSER = require('./avayawebrtc-client-internals.js').FIREFOXBROWSER;
var CHROMEBROWSER = require('./avayawebrtc-client-internals.js').CHROMEBROWSER;
var OPERABROWSER = require('./avayawebrtc-client-internals.js');
var INVALIDIP = require('./avayawebrtc-client-internals.js');
var AUDIOMLINE = require('./avayawebrtc-client-internals.js');
var VIDEOMLINE = require('./avayawebrtc-client-internals.js');
var CANDIDATEZEROLINE = require('./avayawebrtc-client-internals.js');
var INVALIDSDP = require('./avayawebrtc-client-internals.js');
var CLINE = require('./avayawebrtc-client-internals.js');

var RTCPeerConnection = require('./avayawebrtc-client-internals.js').RTCPeerConnection;
var getMediaDevices = require('./avayawebrtc-client-internals.js').getMediaDevices;
var getUserMedia = require('./avayawebrtc-client-internals.js').getUserMedia;
var attachMediaStream = require('./avayawebrtc-client-internals.js').attachMediaStream;
var reattachMediaStream = require('./avayawebrtc-client-internals.js');
var webrtcDetectedBrowser = require('./avayawebrtc-client-internals.js').webrtcDetectedBrowser;
var webrtcDetectedVersion = require('./avayawebrtc-client-internals.js').webrtcDetectedVersion;
var requestAnimationFrame = require('./avayawebrtc-client-internals.js');
var detachMediaStream = require('./avayawebrtc-client-internals.js').attachMediaStream;

var attachFile = require('./avayawebrtc-client-internals.js').attachFile;


var ___internals = internals.___internals;
// Please update this file name variable upon renaming this file
var AVAYAWEBRTC_CLIENT_SCRIPT_NAME = "avayawebrtc-client.js";

//load some scripts
if (!window.jQuery) {
    console.log("throw new Error: jQuery is not included in your page."); 
}

//get url to setup additional scripts
var scriptsBasicUrl = getScriptBasicUrl(AVAYAWEBRTC_CLIENT_SCRIPT_NAME);
$.ajaxSetup({ async: false });
$.getScript(scriptsBasicUrl + "avayawebrtc-client-internals.js", function () {
});
$.ajaxSetup({ async: true });
/**
   avayaWebRTC class is the namespace that includes all module classes and global constants.
   Additionally, the namespace contains protected global util methods and properties used by
   avayaWebRTC namespace classes.

            //create client
            var client = new avayaWebRTC.Client; // creating module classes under avayaWebRTC namespace

            //subscribe to client onNotificationCB event
            client.onNotificationCB = notificationCB;

            function notificationCB(code, reason, severity, description) {
                //check client notification code for specific value
                switch (code) {
                    case avayaWebRTC.ERR_CLIENT_ERROR: // using AvayaWebRTC module constants under avayaWebRTC namespace
                        switch (reason) {
                            case avayaWebRTC.ERR_REASON_NOT_CONNECTED: // using AvayaWebRTC module constants under avayaWebRTC namespace
                            case avayaWebRTC.ERR_REASON_SOCKET_ERROR: // using AvayaWebRTC module constants under avayaWebRTC namespace
                                //connect/disconnect will not return callback in such case
                                //enable/disable some GUI
            			        break;
                        }
                        break;
                    case avayaWebRTC.ERR_SERVER_ERROR_CONNECTION_FAILED: // using AvayaWebRTC module constants under avayaWebRTC namespace
                    case avayaWebRTC.ERR_SERVER_ERROR_DISCONNECT_FAILED: // using AvayaWebRTC module constants under avayaWebRTC namespace
                        //enable/disable some GUI
		                break;
                }
            }


    @class     avayaWebRTC
    @static
 **/


var avayaWebRTC = new function ()
{
    //definitions

    var CFG_CLIENT_VERSION = "1.0";

    //server messages
    /**
    Name of a server message received upon  successful connection to the client

    property SERVER_MSG_CONNECTED
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CONNECTED = "ServerMessageClientConnected";
    /**
    Name of a server message received upon  disconnection from the client

    property SERVER_MSG_DISCONNECTED
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_DISCONNECTED = "ServerMessageClientDisconnected";
    /**
    Name of a server message received upon an error on the server side

    property SERVER_MSG_ERROR
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_ERROR = "ServerMessageError";
    /**
    Name of a server message received upon an SDP answer from the remote side

    property SERVER_MSG_CALL_SDP_ANSWER
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CALL_SDP_ANSWER = "ServerMessageCallSdpAnswer";
    /**
    Name of a server message received when an error occurs during a call

    property SERVER_MSG_CALL_ERROR
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CALL_ERROR = "ServerMessageCallError";
    /**
    Name of a server message received upon call disconnection

    property SERVER_MSG_CALL_DISCONNECTED
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CALL_DISCONNECTED = "ServerMessageCallDisconnected";
    /**
    Name of a server message received upon successful call establishment

    property SERVER_MSG_CALL_CONNECTED
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CALL_CONNECTED = "ServerMessageCallConnected";
    /**
    Name of a server message received when call is in ringing state on the callee side

    property SERVER_MSG_CALL_RINGING
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CALL_RINGING = "ServerMessageCallRinging";
    /**
    Name of the server message received when media is detected on the callee side

    property SERVER_MSG_CALL_REMOTE_MEDIA_DETECTED
    @type String
    @private
    @static
    @final
    **/
    var SERVER_MSG_CALL_REMOTE_MEDIA_DETECTED = "ServerMessageCallRemoteMediaDetected";

    //server errors
    /**
    Error code received from the server when an attempt to connect failed.

    @property ERR_SERVER_ERROR_CONNECTION_FAILED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_ERROR_CONNECTION_FAILED = -1;
    /**
    Error code received from the server upon a failure in disconnection attempt.

    @property ERR_SERVER_ERROR_DISCONNECT_FAILED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_ERROR_DISCONNECT_FAILED = -2;

    /**
    Error code received from the server when sending of SDP offer by call fails.
    NOTE: This code is NOT exposed to application but only used internally by AvayaWebRTC module.
          Instead the application would get a CALL_ERROR_INITIATE_FAILED call error code.


    property SERVER_MSG_DISCONNECTED
    @type String
    @private
    @static
    @final
    **/
    var ERR_SERVER_ERROR_SDPOFFER_FAILED = -3;

    /**
    Error code received from the server when an attempt to disconnect the call fails.

    @property ERR_SERVER_ERROR_CALL_DISCONNECT_FAILED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_ERROR_CALL_DISCONNECT_FAILED = -4;

    //server err code reasons
    /**
    Error code reason received from the server when the error state is unknown.

    @property ERR_SERVER_REASON_UNKNOWN
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_UNKNOWN = -2000;
    /**
    Error code reason received from the server when an authorization failure occurs.

    @property ERR_SERVER_REASON_AUTHORIZATION_FAILED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_AUTHORIZATION_FAILED = -2001;
    /**
    Error code reason received from the server upon an attempt to establish a session
    which is already set up.

    @property ERR_SERVER_REASON_SESSION_CONNECTED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_SESSION_CONNECTED = -2002;
    /**
    Error code reason received from the server upon an attempt to refer to a session
    which is not set up on the server side.

    @property ERR_SERVER_REASON_SESSION_NOT_CONNECTED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_SESSION_NOT_CONNECTED = -2003;
    /**
    Error code reason received from the server when an attempt has been made to establish more simultaneous calls than the server is capable of handling.
    simultaneous  calls than the server is capable of handling.

    @property ERR_SERVER_REASON_SESSION_MAX_CALLS_LIMIT_EXCEEDED
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_SESSION_MAX_CALLS_LIMIT_EXCEEDED = -2004;
    /**
    Error code reason received from the server when the calleeï¿½s state is BUSY.

    @property ERR_SERVER_REASON_CALL_BUSY
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_CALL_BUSY = -2005;
    /**
    Error code reason received from the server upon failure to locate the callee

    @property ERR_SERVER_REASON_CALL_NO_SUCH_DESTINATION
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_CALL_NO_SUCH_DESTINATION = -2006;
    /**
    Error code reason received from the server when an attempt is made to refer a call that hasnï¿½t yet been set up

    @property ERR_SERVER_REASON_CALL_NOT_EXISTING
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_CALL_NOT_EXISTING = -2007;

    /**
    Error code reason received from the server upon connection attempt with an invalid license.

    @property ERR_SERVER_REASON_LICENSE_INVALID
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_LICENSE_INVALID = -2008;

    /**
    Error code reason received from the server upon an attempt to initiate a call when the remote party is not responding.

    @property ERR_SERVER_REASON_CALL_NOT_RESPONDING
    @type Number
    @static
    @final
    **/
    this.ERR_SERVER_REASON_CALL_NOT_RESPONDING = -2009;

    //messages from client to server
    /**
    Name of the client message sent to a server to establish a session connection
    between them.

    property CLIENT_MSG_CONNECT
    @type String
    @private
    @static
    @final
    **/
    var CLIENT_MSG_CONNECT = "ClientMessageConnect";
    /**
    Name of a client message sent to a server to disconnect a session between them

    property CLIENT_MSG_DISCONNECT
    @type String
    @private
    @static
    @final
    **/
    var CLIENT_MSG_DISCONNECT = "ClientMessageDisconnect";
    /**
    Name of a client message sent towards a server with a SDP offer to establish a call

    property CLIENT_MSG_CALL_SDP_OFFER
    @type String
    @private
    @static
    @final
    **/
    var CLIENT_MSG_CALL_SDP_OFFER = "ClientMessageCallSdpOffer";
    /**
    Name of a client message sent towards a server to disconnect a call

    property CLIENT_MSG_CALL_DISCONNECT
    @type String
    @private
    @static
    @final
    **/
    var CLIENT_MSG_CALL_DISCONNECT = "ClientMessageCallDisconnect";

    //end of server constants
    ////////////////////////////////////////////////////////////////////////////

    /**
    Log mask that suppresses log printing.

    @property LOG_ENABLE_NONE
    @type String
    @static
    @final
    **/
    this.LOG_ENABLE_NONE = 'none';

    /**
    Log mask that limits log printing to error and warning logs.

    @property LOG_ENABLE_BASIC
    @type String
    @static
    @final
    **/
    this.LOG_ENABLE_BASIC = 'basic';

    /**
    Log mask that allows all logs to be printed

    @property LOG_ENABLE_FULL
    @type String
    @static
    @final
    **/
    this.LOG_ENABLE_FULL = 'full';


    /**
    INFORMATION logging level type.

    @property LOG_INFO
    @type Number
    @static
    @final
    **/
    this.LOG_INFO = 0;
    /**
    WARNING logging level type.

    @property LOG_WARN
    @type Number
    @static
    @final
    **/
    this.LOG_WARN = 1;
    /**
    ERROR logging level type.

    @property LOG_ERROR
    @type Number
    @static
    @final
    **/
    this.LOG_ERROR = 2;

    /**
    IDLE call state.

    @property CALL_STATE_IDLE
    @type Number
    @static
    @final
    **/
    this.CALL_STATE_IDLE = 0;
    /**
    CONNECTED call state.

    @property CALL_STATE_CONNECTED
    @type Number
    @static
    @final
    **/
    this.CALL_STATE_CONNECTED = 1;

    /**
    INFO level of notification

    @property CLIENT_NOTIFICATION_INFO
    @type Number
    @static
    @final
    **/
    this.CLIENT_NOTIFICATION_INFO = 0;
    /**
    WARNING level of notification

    @property CLIENT_NOTIFICATION_WARNING
    @type Number
    @static
    @final
    **/
    this.CLIENT_NOTIFICATION_WARNING = 1;
    /**
    ERROR level of notification

    @property CLIENT_NOTIFICATION_ERROR
    @type Number
    @static
    @final
    **/
    this.CLIENT_NOTIFICATION_ERROR = 2;

    /**
    Code of a client event passed to the application regarding the state of the client socket.
    For example, the application may be notified of a temporary connectivity loss.

    @property CLIENT_EVENT_SOCKET_MESSAGE
    @type Number
    @static
    @final
    **/
    this.CLIENT_EVENT_SOCKET_MESSAGE = 1500;

    //client notification events
    /**
    Code of reason that a client event passed to the application. The following code type describes a connection loss
    and re-connect attempt.

    @property CLIENT_EVENT_REASON_SOCKET_RECONNECTING
    @type Number
    @static
    @final
    **/
    this.CLIENT_EVENT_REASON_SOCKET_RECONNECTING = 2500;

    //client notification errors
    /**
    General error code in the client which is passed to the application. This error code will be followed by a specific reason code.

    @property ERR_CLIENT_ERROR
    @type Number
    @static
    @final
    **/
    this.ERR_CLIENT_ERROR = -1500;

    //client errors reasons
    /**
	Reason code for an error due to an unknown error in the client.

    @property ERR_REASON_UNKNOWN_ERROR
    @type Number
    @static
    @final
    **/
    this.ERR_REASON_UNKNOWN_ERROR = -999;
    /**
    Reason code for an error due to already connected client.

    @property ERR_REASON_ALREADY_CONNECTED
    @type Number
    @static
    @final
    **/
    this.ERR_REASON_ALREADY_CONNECTED = -1000;
    /**
    Reason code for an error due to not connected client

    @property ERR_REASON_NOT_CONNECTED
    @type Number
    @static
    @final
    **/
    this.ERR_REASON_NOT_CONNECTED = -1001;
    /**
    Reason code for an error due to internal socket error. This reason is usually followed by a detailed description.

    @property ERR_REASON_SOCKET_ERROR
    @type Number
    @static
    @final
    **/
    this.ERR_REASON_SOCKET_ERROR = -1002;
    /**
    Reason code for an error due to a STUN failure

    @property ERR_REASON_STUN_ERROR
    @type Number
    @static
    @final
    **/
    this.ERR_REASON_STUN_ERROR = -1003;

    //call errors
    /**
    Error code for failure in call establishment. This code will be followed by a specific reason code.


    @property CALL_ERROR_INITIATE_FAILED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_INITIATE_FAILED = -2000;
    /**
    Error code for failure in call establishment. This code will be followed by a specific reason code.
    In case of such error, the call state will become DISCONNECTED and will be ready for destruction.

    @property CALL_ERROR_DISCONNECT_FAILED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_DISCONNECT_FAILED = -2001;

    //call error reasons
    /**
    Reason code for call error due to disconnected client.

    @property CALL_ERROR_REASON_CLIENT_NOT_CONNECTED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_CLIENT_NOT_CONNECTED = -2500;
    /**
    Reason code for call error due to invalid destination address (e.g. dialingAddress)

    @property CALL_ERROR_REASON_INVALID_INPUT
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_INVALID_INPUT = -2501;
    /**
    Reason code for call error due to disconnected call

    @property CALL_ERROR_REASON_DISCONNECTED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_DISCONNECTED = -2502;
    /**
    Reason code for call error due to user denial of webbrowser access to media devices like microphone or camera (by pushing the browser Deny button).

    @property CALL_ERROR_REASON_GET_MEDIA_FAILURE
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_GET_MEDIA_FAILURE = -2503;
    /**
    Reason code for call error due to lack of STUN candidates

    @property CALL_ERROR_REASON_EMPTY_CANDIDATES_LIST
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_EMPTY_CANDIDATES_LIST = -2504;
    /**
    Reason code for call error due to a failure in handling the local description of WebRTC PeerConnection

    @property CALL_ERROR_REASON_PEER_CONNECTION_LOCAL_DESCRIPTION_FAILED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_PEER_CONNECTION_LOCAL_DESCRIPTION_FAILED = -2505;
    /**
    Reason code for call error due to a failure in handling the remote description in WebRTC PeerConnection

    @property CALL_ERROR_REASON_PEER_CONNECTION_REMOTE_DESCRIPTION_FAILED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_PEER_CONNECTION_REMOTE_DESCRIPTION_FAILED = -2506;
    /**
    Reason code for call error due to internal error in SDP offer creation by WebRTC PeerConnection

    @property CALL_ERROR_REASON_PEER_CONNECTION_CREATE_OFFER_FAILED
    @type Number
    @static
    @final
    **/
    this.CALL_ERROR_REASON_PEER_CONNECTION_CREATE_OFFER_FAILED = -2507;

    /**
    This method checks if browser supports specific feature or not

    @method IsFeatureSupported
    @param  {String} feature Possible values: 'dtmf','statistics', 'audiocall', 'energy'
    @return {Boolean}
    @public
    **/
    this.IsFeatureSupported = function (feature)
    {
        if(!feature)
            return false;

        if (navigator.mozGetUserMedia) {
            if (feature === "audiocall" || feature === "statistics")
                return true; //only audio call and statistics supported
            return false;
        }

        if (navigator.webkitGetUserMedia) {
            if (feature === "audiocall" || feature === "statistics" || feature === "dtmf" || feature === "energy")
                return true; //all the feature supported
            return false;
        }

        return false;
    }

    //some private variables that will be visible to classes of avayaWebRTC namespace by hidden to outer code.
    /**
    Unique session id for the client
    SessionId is generated locally and sent to server where it is used to identify all messages that
    are relevant to this client session.
    property SessionID
    @type String
    @private
    **/
    var SessionID = "";
    /**
    Socket that enables client-to-server and server-to-client connectivity. (Currently, the long-polling XHR method is used.)

    property serverSocket
    @type avayaWebRTC.Socket
    @private
    **/
    var serverSocket = null;



    function StunAddress() {
        this.ServerAddress = "";
        this.ServerPort = 0;
    }

    /**
    List of StunAddress structures that contains all the STUNs received from the server, ordered by priority.
    The list is generated according to server responses to client connect attempts.

    property STUNAddresses
    @type Array
    @private
    **/
    var STUNAddresses = [];
    /**
    Call refresh rate in seconds. Currently not used because call refreshing is not implemented.
    The value is set according to the server response to the client connect attempt.

    property CallRefreshRateInSec
    @type Number
    @private
    **/
    var CallRefreshRateInSec = 0;
    /**
    A navigator Audio object created to play ringing tone.

    property ringingAudioTag
    @type Audio
    @private
    **/
    var ringingAudioTag = null;
    /**
    A navigator AudioContext (WebAudio) object created for various advanced audio operations such as subscription on outgoing audio energy level

    property audioContext
    @type AudioContext
    @private
    **/
    var audioContext = null;

    /**
    callsCollection is a collection of all the constructed avayaWebRTC.Call objects in the current avayaWebRTC.Client session context. Calls are added to this collection
    in the  avayaWebRTC.Call constructor. Calls are removed from this collection after the call.destroy() method is called.

    callCollection member json is { "call": ..., "peerConnection": ..., "_Disconnect": ...}. It contains avayaWebRTC.Call instance, avayaWebRTC.Call internal private _disconnect method pointer and private avayaWebRTC.Call peerconnection
    property. These additional properties are essential when client object wants to access call private peerconnection member and call private _disconnect method to make some advanced operations.

    property callsCollection
    @type Array
    @private
    **/
    var callsCollection = []; //collection of calls

    ///////////////////////////////////////////////////////////////////////////////////////
    //public callbacks

    // Client callbacks pointer set as properties
    var OnNotification;
    var OnConnectedCallback;
    var OnDisconnectedCallback;

    // Call callbacks pointers set as properties
    var OnCallConnectedCallback;
    var OnCallInitiatingCallback;
    var OnCallRingingCallback;
    var OnCallRemoteDisconnectedCallback;
    var OnCallErrorCallback;
    var OnRemoteMediaConnectedCallback;
    //
    ///////////////////////////////////////////////////////////////////////////////////////

    //private methods
    /**
    This method validates a specific callCollection item.

    method isValidCallData
    @param  {Object} Call data object, build from { "call": ..., "peerConnection": ..., "_Disconnect": ...} json
    @return {Boolean}
    @private
    **/
    var isValidCallData = function (currentCallData) {
        if (!currentCallData || !currentCallData.call || !currentCallData.peerConnection || !currentCallData._drop) {
            return false;
        }
        return true;
    }
    /**
    This method searches callsCollection array and returns calldata object by input call id. If not found, returns null.

    method getCallData
    @param  {String} existing call id
    @return {Object} Object build according { "call": ..., "peerConnection": ..., "_Disconnect": ...} json
    @private
    **/
    var getCallData = function (callid) {
        var foundCalls = $.grep(callsCollection, function (calldata) {
            return (calldata.call.callID === callid);
        });

        if (foundCalls.length == 0) {
            return null;
        }

        return foundCalls[0];
    }
    /**
    This method disconnects all the calls within callsCollection.
    This method is useful for dropping calls upon client disconnection.

    method dropAll
    @private
    **/
    var dropAll = function () {
        var keepCallCollection = callsCollection.slice(0);
        while (keepCallCollection.length > 0) {
            var call = keepCallCollection[0].call;
            if (call !== null && call.callState !== avayaWebRTC.CALL_STATE_IDLE) {
                call.drop();
            }
            if (OnCallRemoteDisconnectedCallback)
                OnCallRemoteDisconnectedCallback(call);
            keepCallCollection.splice(0, 1);
        }
    }
    /**
    Plays ringing tone using input file URL

    method startRingingTone
    @param {String} url_wav url of wav file to play as ringing tone
    @private
    **/
    var startRingingTone = function (url_wav) {
        if (ringingAudioTag)
            return; //already existing and playing. do not duplicate ringing tone.

        if (url_wav.trim() !== "") {
            //start playing ringing tone here
            ringingAudioTag = playAudioFile(url_wav, true);
        }
    }
    /**
    Stops playing ringing tone

    method stopRingingTone
    @private
    **/
    var stopRingingTone = function () {
        if (ringingAudioTag)
            clearAudioTag(ringingAudioTag, "");
        ringingAudioTag = undefined;
    }
    /**
    A utility method that cleans input audio tag src url.
    This method may be used to stop playing an audio file.

    method clearAudioTag
    @param {Audio} audioElement audio object to clear
    @private
    **/
    var clearAudioTag = function (audioElement) {
        if (audioElement !== undefined && audioElement !== null)
            attachFile(audioElement, "");
    }
    /**
    A utility method that optionally creates audioelement (audio object) and configures it to play a wav sound file

    method playAudioFile
    @param {String} soundfile_wav url of file to play
    @param {Boolean} loop loop or do not loop the file playing
    @param {Audio} audioElement audio object to clear
    @return {Audio} audio object that is playing the audio file
    @private
    **/
    var playAudioFile = function (soundfile_wav, loop, audioElement) {
        if (audioElement === undefined) {
            audioElement = new Audio();
        }

        if (!!(audioElement.canPlayType && audioElement.canPlayType('audio/wav;').replace(/no/,
                ''))) {
            attachFile(audioElement, soundfile_wav);
            if (loop !== undefined) {
                audioElement.loop = loop;
            }
            return audioElement;
        }

        return audioElement;
    }

    /*******************************************************************************************************************
     *
     *  Internal class wrapping jquery ajax long polling method
     *
     */
     this.Socket = function (sessionid) {
        ////////////////////////////////////////////////////////////////////////////////////////
        //
        var messagesAndCallbacks = [];
        var serverUrl = "";
        var stop = false;
        var currentRetries = 0;
        var retryTimeout = 5000;
        var connectionTimeout = 20000;
        var numberOfRetries = 10000;
        var sessionId = sessionid;
        var connected = false;

        function put(url, data, callback) {
            $.support.cors = true;
            $.ajax(url, {
                type: 'POST',
                crossDomain: true,
                data: JSON.stringify(data),
                contentType: 'text/plain',
                success: function () { if (callback) callback(true); },
                error: function () { if (callback) callback(false); }
            });
        }
        function get(url, data, callback) {
            $.support.cors = true;
            $.ajax(url + '?json=' + JSON.stringify(data), {
                type: 'GET',
                crossDomain: true,
                dataType: 'text',
                success: function (success) { if (callback) callback(success); },
                error: function () { if (callback) callback(null); }
            });
        }
        function poll(xhr, status) {
            if (stop) {
                if (messagesAndCallbacks['disconnect'] != undefined)
                    messagesAndCallbacks['disconnect']();
                return;
            }

            if (status != undefined) {
                switch (status) {
                    case "success":
                        break;
                    case "notmodified":
                        break;
                    case "error":
                        if (currentRetries >= numberOfRetries) {
                            if (messagesAndCallbacks['error'])
                                messagesAndCallbacks['error']("server connection is lost after exceeding max retries");
                            if (messagesAndCallbacks['disconnect'])
                                messagesAndCallbacks['disconnect']();
                            stop = true;
                        }
                        else {
                            if (currentRetries > 0) {
                                if (messagesAndCallbacks['reconnect_failed'])
                                    messagesAndCallbacks['reconnect_failed']();
                            }

                            currentRetries++;
                            setTimeout(function () {
                                if (messagesAndCallbacks['reconnecting'])
                                    messagesAndCallbacks['reconnecting']();
                                poll();

                            }, retryTimeout);
                            return;
                        }
                        break;
                    case "timeout":
                        break;
                    case "abort":
                        if (messagesAndCallbacks['disconnect'])
                            messagesAndCallbacks['disconnect']();
                        stop = true;
                        break;
                    case "parsererror":
                        if (messagesAndCallbacks['error'])
                            messagesAndCallbacks['error']("parsererror");
                        break;
                }
            }
            if (stop) {
                if (messagesAndCallbacks['disconnect'])
                    messagesAndCallbacks['disconnect']();
                return;
            }
            //'?json=' + JSON.stringify(pollingmsg)
            //var pollingmsg = { "name": "polling", "args": [{ "sessionid": sessionId}] };

            var pollingquery = "?name=polling&sessionid=" + sessionId;

            $.ajax({ url: serverUrl + pollingquery,
                type: 'GET',
                crossDomain: true,
                dataType: "text",
                success: function (responseString) {
                    if (currentRetries !== 0) {
                        if (messagesAndCallbacks['reconnect'])
                            messagesAndCallbacks['reconnect']();
                        currentRetries = 0;
                    }
                    var data = undefined;
                    try {
                        data = JSON.parse(responseString);
                    }
                    catch (e) {
                        //protection from server bugs
                    }

                    var eventsArray = [];
                    if ($.isArray(data))
                        eventsArray = data;
                    else
                        eventsArray.push(data);

                    for (var counter = 0; counter < eventsArray.length; counter++) {
                        handleSingleEvent(eventsArray[counter]);
                    }
                    function handleSingleEvent(event) {
                        var isvaliddata = true;
                        if (event === undefined || event.name === undefined || event.args === undefined || event.args.length === undefined) {
                            isvaliddata = false;
                        }

                        var calledcallback = undefined;
                        if (isvaliddata)
                            calledcallback = messagesAndCallbacks[event.name]

                        //fallback case
                        if (calledcallback === undefined && (event !== undefined && event.name !== undefined)) //name specified but unhandled
                            calledcallback = messagesAndCallbacks['message']; //raise unspecified message

                        if (calledcallback === undefined)
                            return; //not handled

                        if (isvaliddata)
                            calledcallback(event.args[0]);
                        else
                            calledcallback();
                    }
                },
                error: function () {
                },
                complete: (!stop) ?
                        poll : function () {
                            if (messagesAndCallbacks['disconnect'])
                                messagesAndCallbacks['disconnect']();
                        },
                timeout: connectionTimeout
            });
        };

        ////////////////////////////////////////////////////////////////////////////////////////
        this.disconnect = function () {
            stop = true;
            connected = false;
        }
        ////////////////////////////////////////////////////////////////////////////////////////
        this.connect = function (url, callback, timeoutcfg, retriescfg, retrytimeoutcfg) {
            serverUrl = url;
            if (timeoutcfg != undefined)
                connectionTimeout = timeoutcfg;
            if (retriescfg != undefined) {
                numberOfRetries = retriescfg;
            }
            if (retrytimeoutcfg != undefined) {
                retryTimeout = retrytimeoutcfg;
            }

            currentRetries = 0;
            poll();
        }
        ////////////////////////////////////////////////////////////////////////////////////////
        this.on = function (message, callback) {
            messagesAndCallbacks[message] = callback;
        }
        ////////////////////////////////////////////////////////////////////////////////////////
        this.emit = function (message, rawdata, callback, type, binary) {
            var jqxhr = null;

            var data = { "name": message, "args": [] };
            data.args.push(rawdata);
            
            if (type === undefined) {
            	type = 'post';
            }
                        	
            if (type === 'post') {
            	put(serverUrl, data, callback);
            } else {
            	get(serverUrl, data, callback);
            }
        }
        ////////////////////////////////////////////////////////////////////////////////////////
    }

    /**
        This object is required in order to maintain a WebRTC session. A Client object can have one or more connected calls.
        Usage example:

            //construction
            var client = new avayaWebRTC.Client();

            //initialization
            client.enableLogs = true;
            client.domain = 'unknown.com';
            client.username = "unknown";
        	client.securityToken = "SomeSecurityToken";

            //callbacks registrations, supposing we have all callbacks implemented in the script
            client.onConnectedCB                            =     connectedCB;
            client.onDisconnectedCB                         =     disconnectedCB;
            client.onNotificationCB                         =     notificationCB;
            client.onCallConnectedCB                        =     onCallConnectedCB;
            client.onCallInitiatingCB                       =     onCallInitiatingCB;
            client.onCallRingingCB                          =     onCallRingingCB;
            client.onCallRemoteDisconnectedCB               =     onCallRemoteDisconnectedCB;
            client.onCallErrorCB                            =     onCallErrorCB;
            client.onRemoteMediaConnectedCB                 =     onRemoteMediaConnectedCB;

            //connection - calling asynchronous method to connect and waiting for CONNECTED event or other client error notification.
            client.connect();


            //disconnection - calling asynchronous method to disconnect and waiting for DISCONNECTED event or other client error notification.
            client.disconnect();

        @namespace avayaWebRTC
        @class Client
        @constructor
    **/
    this.Client = function () {

        //initialize all the public properties

        ///////////////////////////////////////////////////////////////////////////////////////
        //public properties
        /**
        Client user name. Reserved for future use.

        @property username
        @type String
        @default ""
        **/
        this.username = "";


        /**
        WebRTC server address.
        The address accessed while trying to establish a WebRTC call.
        This address is set to the Avaya Session Border Controller For Enterprise address or to the Avaya Breeze load balancer in a cluster address.


        @property webRTCHTTPAddress
        @type String
        @default ""
        @required
        **/
        var _webRTCHTTPAddress = "";
        Object.defineProperty(this, "webRTCHTTPAddress", {
            configurable: true,
            get: function () {
                return _webRTCHTTPAddress;
            },
            set: function (val) {
                _webRTCHTTPAddress = val;
            }
        });

        /**
        Log mask for printing log messages to navigator console.
        Possible values: LOG_ENABLE_NONE,LOG_ENABLE_BASIC,LOG_ENABLE_FULL

        @property enableLogs
        @type String
        @default LOG_ENABLE_NONE
        @optional
        **/
        this.enableLogs = avayaWebRTC.LOG_ENABLE_NONE;

        /**
        Security token to be set to enable client authorization by the server.
        The security token is generated by the application server.
        It is used for authorization through the WebRTC client connection
        to the WebRTC snap-in.

        @property securityToken
        @type String
        @default ""
        @required
        **/
        this.securityToken = "";
        /**
		Domain of the Web application URL. Reserved for future use.

		@property domain
		@type String
		@default ""
        **/
        this.domain = "";
        //
        ///////////////////////////////////////////////////////////////////////////////////////

        var that = this;

        /////////////////////////////////////////////
        // Public properties
        /**
        Returns current connection status of the client (Connected or Not Connected)

        @property   isConnected
        @type       {Boolean}
        @readOnly
        **/
        Object.defineProperty(this, "isConnected", {
            configurable: true,
            get: function () {
                if (serverSocket !== null)
                    return true;
                return false;
            }
        });

        /////////////////////////////////////////////
        // Public methods
        /**
        Establishes a connection to a server.

        @method connect
        @async
        **/
        this.connect = function () {
            this.log(avayaWebRTC.LOG_INFO, "Client::connect <--");
            if (this.isConnected) {
                if (OnNotification)
                    OnNotification(avayaWebRTC.ERR_CLIENT_ERROR, avayaWebRTC.ERR_REASON_ALREADY_CONNECTED, avayaWebRTC.CLIENT_NOTIFICATION_ERROR, "Client already connected");
                this.log(avayaWebRTC.LOG_ERROR, "connect: already connected");
                return;
            }

            SessionID = ___internals.createUuid();

            serverSocket = new avayaWebRTC.Socket(SessionID);
            serverSocket.connect(this.webRTCHTTPAddress, null, 60000, 10000, 5000);

            //////////////////////////////////////////////
            //default predefined messages to be logged
            serverSocket.on('error', function (reason) {
                that.log(avayaWebRTC.LOG_ERROR, "Unable to connect socket " + reason);
                if (OnNotification) {
                    OnNotification(avayaWebRTC.ERR_CLIENT_ERROR, avayaWebRTC.ERR_REASON_SOCKET_ERROR, avayaWebRTC.CLIENT_NOTIFICATION_ERROR, "Unable to connect server: " + reason);
                }
                return;
            });

            serverSocket.on('connect', function () {
                that.log(avayaWebRTC.LOG_INFO, 'successfully established a working socket connection');
            });
            serverSocket.on('connecting', function () {
                that.log(avayaWebRTC.LOG_INFO, 'socket is attempting to connect with the server');
            })
            serverSocket.on('connect_failed', function () {
                that.log(avayaWebRTC.LOG_ERROR, 'socket failed to establish a connection to the server');
                //if (OnNotification)
                //    OnNotification(avayaWebRTC.ERR_CLIENT_ERROR, avayaWebRTC.ERR_REASON_SOCKET_ERROR, "Unable to connect server");
            })
            serverSocket.on('reconnect_failed', function () {
                that.log(avayaWebRTC.LOG_ERROR, 'socket failed to re-establish a working connection after the connection was dropped');
                //if (OnNotification) {
                //  OnNotification(avayaWebRTC.ERR_CLIENT_ERROR, avayaWebRTC.ERR_REASON_SOCKET_ERROR, "Unable to reconnect server");
                //}
            })
            serverSocket.on('reconnect', function () {
                that.log(avayaWebRTC.LOG_INFO, 'socket successfully reconnected to the server.');
            })
            serverSocket.on('reconnecting', function () {
                that.log(avayaWebRTC.LOG_WARN, 'socket is attempting to reconnect');
                if (OnNotification) {
                    OnNotification(avayaWebRTC.CLIENT_EVENT_SOCKET_MESSAGE, avayaWebRTC.CLIENT_EVENT_REASON_SOCKET_RECONNECTING, avayaWebRTC.CLIENT_NOTIFICATION_WARNING, "Server connection is temporally lost. Socket trying to reconnect.");
                }
            })
            serverSocket.on('disconnect', function () {
                that.log(avayaWebRTC.LOG_INFO, 'socket disconnected');
                //be sure to send drop to all the possible calls.
                dropAll();
                serverSocket = null; //in current stage, it will signify to all the users of socket that it is disconnected
            });
            serverSocket.on('message', function (message, callback) {
                that.log(avayaWebRTC.LOG_INFO, 'socket sent unhandled message: ' + message);
            });
            serverSocket.on('anything', function (data, callback) {
                that.log(avayaWebRTC.LOG_INFO, 'socket sent anything message');
            });
            //
            //////////////////////////////////////////////

            //////////////////////////////////////////////
            //client messages

            //connected msg
            serverSocket.on(SERVER_MSG_CONNECTED, function (sessionCfg) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + SERVER_MSG_CONNECTED);
                STUNAddresses.splice(0, STUNAddresses.length);
                for (var stunIndex = 0; stunIndex < sessionCfg.stuns.length; stunIndex++) {
                    var stun = new StunAddress();
                    stun.ServerAddress = sessionCfg.stuns[stunIndex].stunserveraddress;
                    stun.ServerPort = sessionCfg.stuns[stunIndex].stunserverport;
                    STUNAddresses.push(stun);
                }

                CallRefreshRateInSec = sessionCfg.callrefreshrateinsec;

                if (OnConnectedCallback)
                    OnConnectedCallback();
            });

            //disconnected msg
            serverSocket.on(SERVER_MSG_DISCONNECTED, function () {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + SERVER_MSG_DISCONNECTED);
                dropAll();
                if (serverSocket)
                    serverSocket.disconnect();
                serverSocket = null;
                if (OnDisconnectedCallback)
                    OnDisconnectedCallback();
            });

            //error msg
            serverSocket.on(SERVER_MSG_ERROR, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + SERVER_MSG_ERROR + ": " + data.description);
                //for some cases autodisconnect the session
                if (data.code === avayaWebRTC.ERR_SERVER_ERROR_CONNECTION_FAILED) {
                    that.log(avayaWebRTC.LOG_ERROR, "Disconnect existing connect because of server connection refused for some reason");
                    if (serverSocket)
                        serverSocket.disconnect();
                    serverSocket = null;
                }
                else if (data.reason === avayaWebRTC.ERR_SERVER_REASON_SESSION_NOT_CONNECTED) {
                    that.log(avayaWebRTC.LOG_ERROR, "Could not find the session for some reason.");
                    if (serverSocket)
                        serverSocket.disconnect();
                    serverSocket = null;
                }

                //notify error
                if (OnNotification) {
                    OnNotification(data.code, data.code, avayaWebRTC.CLIENT_NOTIFICATION_ERROR, data.description);
                }
            });
            //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //call messages
            //sdp answer
            serverSocket.on(SERVER_MSG_CALL_SDP_ANSWER, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + SERVER_MSG_CALL_SDP_ANSWER + 
                		" for UCID = " + data.ucid);

                //get peer connection of specific call
                var currentCallData = getCallData(data.callid);
                currentCallData.call.UCID = data.ucid;

                //protection from server errors
                if (!isValidCallData(currentCallData)) {
                    that.log(avayaWebRTC.LOG_WARN, "callid " + data.callid + " context is invalid. Possible outdates server message");
                    return;
                }

                function onSetRemoteDescriptionError(error) {
                    that.log(avayaWebRTC.LOG_ERROR, "Call::Dial  -- set remote peer connection session description failed. " + error);
                    serverSocket.emit(CLIENT_MSG_CALL_DISCONNECT, {
                            "sessionid": SessionID,
                            "callid": data.callid
                        },
                        function (success)
                        {
                            if (!success) {
                                console.log(avayaWebRTC.LOG_ERROR, "Client:Disconnect -- emit(" + CLIENT_MSG_CALL_DISCONNECT + ") failed. Socket error");

                                if (OnCallErrorCallback)
                                    OnCallErrorCallback(currentCallData.call, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.ERR_REASON_SOCKET_ERROR, "Failed to hang up after server error. Socket error.");
                                currentCallData._drop.call(currentCallData.call, false, false); //release resources
                            }
                        });
                }

                var remoteSessionDescription = undefined;
                try {
                    //if sdp string is invalid, sometimes type mismatch exception launched and not the right error callback
                    //it is protection from server bugs
                    remoteSessionDescription = new RTCSessionDescription({ type: 'answer', sdp: data.sdpanswer });
                }
                catch (e) {
                    onSetRemoteDescriptionError(e.message + " SDP answered from remote party possibly invalid.");
                    return;
                }
                currentCallData.peerConnection.setRemoteDescription(remoteSessionDescription,
                    function () {
                        that.log(avayaWebRTC.LOG_INFO, "Call::Dial  -- set remote peer connection session description succeeded");
                    }
                    ,
                    onSetRemoteDescriptionError
                    );
            });

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            serverSocket.on(SERVER_MSG_CALL_RINGING, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + 
                		SERVER_MSG_CALL_RINGING + "UCID = " + data.ucid);
                //protection from server errors
                var currentCallData = getCallData(data.callid);
                
                if (!isValidCallData(currentCallData)) {
                    that.log(avayaWebRTC.LOG_WARN, "callid " + data.callid + " context is invalid. Possible outdates server message");
                    return;
                }

                if (OnCallRingingCallback)
                    OnCallRingingCallback(that.getCall(data.callid));
            });
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            serverSocket.on(SERVER_MSG_CALL_REMOTE_MEDIA_DETECTED, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + 
                		SERVER_MSG_CALL_REMOTE_MEDIA_DETECTED + "UCID = " + data.ucid);
                stopRingingTone();

                var currentCallData = getCallData(data.callid);
                
                if (!isValidCallData(currentCallData)) {
                    that.log(avayaWebRTC.LOG_WARN, "callid " + data.callid + " context is invalid. Possible outdates server message");
                    return;
                }

                if (OnRemoteMediaConnectedCallback)
                    OnRemoteMediaConnectedCallback(that.getCall(data.callid));
            });
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            serverSocket.on(SERVER_MSG_CALL_CONNECTED, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + 
                		SERVER_MSG_CALL_CONNECTED + "UCID = " + data.ucid);
                stopRingingTone();
                var currentCallData = getCallData(data.callid);
                
                if (!isValidCallData(currentCallData)) {
                    that.log(avayaWebRTC.LOG_WARN, "callid " + data.callid + " context is invalid. Possible outdates server message");
                    return;
                }
                if (OnCallConnectedCallback)
                    OnCallConnectedCallback(that.getCall(data.callid));
            });
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            serverSocket.on(SERVER_MSG_CALL_DISCONNECTED, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + SERVER_MSG_CALL_DISCONNECTED);
                var currentCallData = getCallData(data.callid);
                if (!isValidCallData(currentCallData)) {
                    that.log(avayaWebRTC.LOG_WARN, "callid " + data.callid + " context is invalid. Possible outdates server message");
                    return;
                }

                if (currentCallData.call !== null && currentCallData.call.callState !== avayaWebRTC.CALL_STATE_IDLE) {
                    currentCallData._drop();
                }

                if (OnCallRemoteDisconnectedCallback)
                    OnCallRemoteDisconnectedCallback(currentCallData.call);
            });

            serverSocket.on(SERVER_MSG_CALL_ERROR, function (data) {
                that.log(avayaWebRTC.LOG_INFO, "Server message " + SERVER_MSG_CALL_ERROR + ": " + data.description);

                var currentCallData = getCallData(data.callid);
                if (!isValidCallData(currentCallData)) {
                    that.log(avayaWebRTC.LOG_WARN, "callid " + data.callid + " context is invalid. Possible outdates server message");
                    return;
                }

                currentCallData._drop.call(currentCallData.call, false, false); //release resources

                var codeRemap = data.code;
                if (codeRemap === ERR_SERVER_ERROR_SDPOFFER_FAILED)
                    codeRemap = avayaWebRTC.CALL_ERROR_INITIATE_FAILED; //it is not interesting for external code but only that dial is failed

                if (OnCallErrorCallback)
                    OnCallErrorCallback(that.getCall(data.callid), codeRemap, data.reason, data.description);
            });
            //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            this.log(avayaWebRTC.LOG_INFO, "Client:connect -- connect to server");

            //start connect
            serverSocket.emit(CLIENT_MSG_CONNECT, {
                "securitytoken": this.securityToken,
                "sessionid": SessionID,
                "clientversion": CFG_CLIENT_VERSION,
                "domain": this.domain,
                "username": this.username
            }
            ,
            function (success) {
                if (!success) {
                    if (serverSocket)
                        serverSocket.disconnect();
                    serverSocket = null; //unimportant to continue
                    console.log(avayaWebRTC.LOG_ERROR, "Client:connect -- emit(" + CLIENT_MSG_CONNECT + ") failed. Socket error");
                    if (OnNotification) {
                        OnNotification(avayaWebRTC.ERR_SERVER_ERROR_CONNECTION_FAILED, avayaWebRTC.ERR_REASON_SOCKET_ERROR, avayaWebRTC.CLIENT_NOTIFICATION_ERROR, "Failed to connect client. Socket error.");
                    }
                }
            }
            );

            this.log(avayaWebRTC.LOG_INFO, "connect -->");
        }

        /**
        Disconnects from a server.

        @method disconnect
        @async
        **/
        this.disconnect = function () {
            this.log(avayaWebRTC.LOG_INFO, "Client::disconnect <--");
            if (!this.isConnected) {
                if (OnNotification)
                    OnNotification(avayaWebRTC.ERR_CLIENT_ERROR, avayaWebRTC.ERR_REASON_NOT_CONNECTED, avayaWebRTC.CLIENT_NOTIFICATION_ERROR, "Client not connected");
                this.log(avayaWebRTC.LOG_ERROR, "Client::disconnect: not connected");
                return;
            }

            dropAll(); //force all the calls to disconnect

            serverSocket.emit(CLIENT_MSG_DISCONNECT, { "sessionid": SessionID },
            function (success) {
                if (!success) {
                    console.log(avayaWebRTC.LOG_ERROR, "Client:disconnect -- emit(" + CLIENT_MSG_DISCONNECT + ") failed. Socket error");
                    if (serverSocket)
                        serverSocket.disconnect();
                    serverSocket = null; //unimportant to continue
                    if (OnNotification) {
                        OnNotification(avayaWebRTC.ERR_SERVER_ERROR_DISCONNECT_FAILED, avayaWebRTC.ERR_REASON_SOCKET_ERROR, avayaWebRTC.CLIENT_NOTIFICATION_ERROR, "Failed to disconnect client. Socket error.");
                    }
                }
            }
            );
            this.log(avayaWebRTC.LOG_INFO, "Client::disconnect -->");
        }

        /**
        Retrieves call object from a client calls list by specific callID.

        @method getCall

        @param {String} callID existing call id

        @return {avayaWebRTC.Call} Existing call object or undefined if such callID is not found in the calls collection
        **/
        this.getCall = function (callID) {
            var foundCalls = $.grep(callsCollection, function (calldata) {
                return (calldata.call.callID === callID);
            });

            if (foundCalls.length > 0) {
                return foundCalls[0].call;
            }

            return null;
        }

        /**
        Prints log message of specific type in the console with exact date time with milliseconds only if logEnabled property has been set to true

        @method log

        @param {Number} type Log message type: can be avayaWebRTC.LOG_INFO, avayaWebRTC.LOG_WARN or avayaWebRTC.LOG_ERROR
        @param {String} text Log message description
        **/
        this.log = function (type, text) {
            if (this.enableLogs === avayaWebRTC.LOG_ENABLE_NONE)
                return;

            if (this.enableLogs === avayaWebRTC.LOG_ENABLE_BASIC &&
                type === avayaWebRTC.LOG_INFO)
                return;

            if (text[text.length - 1] == '\n') {
                text = text.substring(0, text.length - 1);
            }

            var dateNow = new Date();
            //compose date time element
            var dateString = dateNow.getFullYear() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getDate() + " ";
            dateString += dateNow.getHours() + ":" + dateNow.getMinutes() + ":" + dateNow.getSeconds() + "." + dateNow.getMilliseconds();

            var subType = "UNKNOWN";
            switch (type) {

                case avayaWebRTC.LOG_INFO:
                    subType = "INFO";
                    console.info(dateString + "  " + subType + " - " + text);
                    break;
                case avayaWebRTC.LOG_WARN:
                    subType = "WARN";
                    console.warn(dateString + "  " + subType + " - " + text);
                    break;
                case avayaWebRTC.LOG_ERROR:
                    subType = "ERROR";
                    console.error(dateString + "  " + subType + " - " + text);
                    break;
                default:
            }
        }

       /**
        An event callback which is fired when client is connected to the server

        @event onConnectedCB
       **/
       Object.defineProperty(this, "onConnectedCB", {
            configurable: true,
            get: function () {
                return OnConnectedCallback;
            },
            set: function (val) {
                OnConnectedCallback = val;
            }
        });
        /**
         An event callback which is fired when client is disconnected from the server

         @event onDisconnectedCB
        **/
       Object.defineProperty(this, "onDisconnectedCB", {
            configurable: true,
            get: function () {
                return OnDisconnectedCallback;
            },
            set: function (val) {
                OnDisconnectedCallback = val;
            }
        });
        /**
         An event callback which is fired when client notification received

         @event onNotificationCB

         @param {Number} code           Code of notification, e.g. avayaWebRTC.ERR_SERVER_ERROR_CONNECTION_FAILED
         @param {Number} reason         Reason of notification code, e.g. avayaWebRTC.ERR_SERVER_REASON_AUTHORIZATION_FAILED
         @param {Number} severity       Notification severity, e.g. avayaWebRTC.CLIENT_NOTIFICATION_ERROR
         @param {String} description    Notification verbal description
        **/
       Object.defineProperty(this, "onNotificationCB", {
            configurable: true,
            get: function () {
                return OnNotification;
            },
            set: function (val) {
                OnNotification = val;
            }
        });
        /**
         An event callback which is fired when call connects successfully

         @event onCallConnectedCB

         @param (avayaWebRTC.Call)              call instance of the event related to
        **/
       Object.defineProperty(this, "onCallConnectedCB", {
            configurable: true,
            get: function () {
                return OnCallConnectedCallback;
            },
            set: function (val) {
                OnCallConnectedCallback = val;
            }
       });

        /**
         An event callback which is fired when call is in initiating state. When this callback is fired, it is possible to drop the call.

         @event onCallInitiatingCB

         @param (avayaWebRTC.Call)              call instance of the event related to
        **/
       Object.defineProperty(this, "onCallInitiatingCB", {
           configurable: true,
           get: function () {
               return OnCallInitiatingCallback;
           },
           set: function (val) {
               OnCallInitiatingCallback = val;
           }
       });

        /**
         An event callback which is fired when call is in ringing state in remote side

         @event onCallRingingCB

         @param (avayaWebRTC.Call)              call instance of the event related to
        **/
       Object.defineProperty(this, "onCallRingingCB", {
            configurable: true,
            get: function () {
                return OnCallRingingCallback;
            },
            set: function (val) {
                OnCallRingingCallback = val;
            }
        });
        /**
         An event callback which is fired when call is disconnected by the remote party

         @event onCallRemoteDisconnectedCB

         @param (avayaWebRTC.Call)              call instance of the event related to
        **/
       Object.defineProperty(this, "onCallRemoteDisconnectedCB", {
            configurable: true,
            get: function () {
                return OnCallRemoteDisconnectedCallback;
            },
            set: function (val) {
                OnCallRemoteDisconnectedCallback = val;
            }
        });
        /**
         An event callback which is fired when a call error is received

         @event onCallErrorCB

         @param (avayaWebRTC.Call)              call instance of the call error is related to

         @param {Number} code           Error code, e.g. avayaWebRTC.CALL_ERROR_INITIATE_FAILED

         @param {Number} reason         Error code reason , e.g. avayaWebRTC.CALL_ERROR_REASON_GET_MEDIA_FAILURE

         @param {String} description    Error textual description
        **/
       Object.defineProperty(this, "onCallErrorCB", {
            configurable: true,
            get: function () {
                return OnCallErrorCallback;
            },
            set: function (val) {
                OnCallErrorCallback = val;
            }
        });
        /**
         An event callback which is fired when call remote media connects

         @event onRemoteMediaConnectedCB

         @param (avayaWebRTC.Call)              call instance of the event related to
        **/
        Object.defineProperty(this, "onRemoteMediaConnectedCB", {
            configurable: true,
            get: function () {
                return OnRemoteMediaConnectedCallback;
            },
            set: function (val) {
                OnRemoteMediaConnectedCallback = val;
            }
        });


    }

       /**
          Data structure for retrieving call energy state, such as local mic volume. This structure is returned by the call.microphoneLevels method

        Usage example as following:

                //example that subscribing in callconnected to get energy layer every 300ms and paint it someway. Supposing we have existing call object
                var energyCollector = setInterval(function () {

                    if (!call)
                        return;

                    if (call.callState === avayaWebRTC.CALL_STATE_IDLE) {
                        return;
                    }

                    //get energy from existing call
                    var microphoneLevels = call.microphoneLevels;

                    //painting energy in someway
                    paintVolumeEnergy(microphoneLevels.localFastMicVolumeLevel, microphoneLevels.localMicClippingLevel);

                }, 300);


           @namespace avayaWebRTC
           @class MicrophoneLevels
           @constructor

        **/
    this.MicrophoneLevels = function () {
        /**
         Local Microphone Volume Level (updated approximately every second)

         @property localMicVolumeLevel
         @type {Number}
         @default 0
         @example
           //Assuming the call is in state CONNECTED. Getting microphone energy level from a call

            var localMicVolumeLevel = theCall.microphoneLevels.localMicVolumeLevel;
        */
        this.localMicVolumeLevel = 0.0;
        /**
          Local Microphone Volume Clipping Level (updated approximately every second)


          @property localMicClippingLevel
          @type {Number}
          @default 0
          @example
           //Assuming the Call is in state CONNECTED. Getting microphone clipping level.

            var localMicClippingLevel = theCall.microphoneLevels.localMicClippingLevel;
        */
        this.localMicClippingLevel = 0.0;
        /**
        * Local Microphone Volume Level (updated approximately every 50ms)
        *
        * @property localFastMicVolumeLevel
        * @type {Number}
        * @default 0
        */
        this.localFastMicVolumeLevel = 0.0;
    }
    /**
        Data structure for retrieving call statistics such as local audio input level.
        The statistics data is applicable for Chrome and Firefox. Not all the statistics 
        properties apply to both browsers. Please Refer to each property or webrtc sample  
        application in SDK for details.

        Usage example:

            //subscribing to refresh statistics of the existing call every second
            setInterval(function () {
                if (!theCall)
	            	return;
                if (theCall.callState === avayaWebRTC.CALL_STATE_IDLE) {
	        		return;
	        	}

                //get call statistics data structure
	            theCall.getStatistics(function (stats) {
                    //update existing html tags with received data
                    $('#localAudioInputLevel').text(stats.localAudioInputLevel);
                    $('#localAudioCodecName').text(stats.localAudioCodecName);
                    $('#localAudioJitterReceived').text(stats.localAudioJitterReceived);
                    $('#localAudioPacketsSent').text(stats.localAudioPacketsSent);
                    $('#localAudioBytesSent').text(stats.localAudioBytesSent);
                    $('#remoteAudioBytesReceived').text(stats.remoteAudioBytesReceived);
                    $('#remoteAudioPacketsLost').text(stats.remoteAudioPacketsLost);
                    $('#remoteAudioPacketsReceived').text(stats.remoteAudioPacketsReceived);
                    $('#remoteAudioOutputLevel').text(stats.remoteAudioOutputLevel);
                    $('#remoteAudioJitterReceived').text(stats.remoteAudioJitterReceived);
                })
            }, 1000);


        @namespace avayaWebRTC
        @class CallStatistics
        @constructor
    **/
    this.CallStatistics = function () {

        /**
        * Local Audio Input Level
        * Applicable for only Chrome
        * 
        * @property localAudioInputLevel
        * @type {Number}
        * @default 0
        */
        this.localAudioInputLevel = "0";
        /**
        * Local Audio Codec Name
        * Applicable for only Chrome
        * 
        * @property localAudioCodecName
        * @type {String}
        * @default 0
        */
        this.localAudioCodecName = "";
        /**
        * Local Audio Jitter Received
        * Applicable for only Chrome
        * 
        * @property localAudioJitterReceived
        * @type {Number}
        * @default ""
        */
        this.localAudioJitterReceived = "0";
        /**
        * Local Audio Packets Sent
        * Applicable for both Chrome and Firefox
        * 
        * @property localAudioPacketsSent
        * @type {Number}
        * @default 0
        */
        this.localAudioPacketsSent = "0";
        /**
        * Local Audio Bytes Sent
        * Applicable for both Chrome and Firefox
        *
        * @property localAudioBytesSent
        * @type {Number}
        * @default 0
        */
        this.localAudioBytesSent = "0";
        /**
        * Remote Audio Bytes Received
        * Applicable for both Chrome and Firefox
        * 
        * @property remoteAudioBytesReceived
        * @type {Number}
        * @default 0
        */
        this.remoteAudioBytesReceived = "0";
        /**
        * Remote Audio Packets Lost
        * Applicable for both Chrome and Firefox
        *
        * @property remoteAudioPacketsLost
        * @type {Number}
        * @default 0
        */
        this.remoteAudioPacketsLost = "0";
        /**
        * Remote Audio Packets Received
        * Applicable for both Chrome and Firefox
        * 
        * @property remoteAudioPacketsReceived
        * @type {Number}
        * @default 0
        */
        this.remoteAudioPacketsReceived = "0";
        /**
        * Remote Audio Output Level
        * Applicable for only Chrome
        * 
        * @property remoteAudioOutputLevel
        * @type {Number}
        * @default 0
        */
        this.remoteAudioOutputLevel = "0";
        /**
        * Remote Audio Jitter Received
        * Applicable for both Chrome and Firefox
        * 
        * @property remoteAudioJitterReceived
        * @type {Number}
        * @default 0
        */
        this.remoteAudioJitterReceived = "0";
    }

    /**
        This object is responsible for call maintenance within a session.

        Usage example:


            //Assuming avayaWebRTC.Client was created and connected to server and web page is subscribed to all the events fired by client
            function onCallErrorCB(call, code, reason, description) {
			    switch(code)
			    {
			        case avayaWebRTC.CALL_ERROR_INITIATE_FAILED:
    			        call.destroy();
                        //enable/disable some GUI
			    }
            };

            function onCallConnectedCB(call){
                //call is successfully connected, enable or disable some UI
            }

            function onCallRemoteDisconnectedCB(call) {
                //call is successfully disconnected, enable or disable some UI
            }

            //create new call and pass client instance as parameter.
            var theCall = new avayaWebRTC.Call(client);

            //optional - set ringing sound file wav file
            theCall.ringingFileUrl = 'mywebsite.com/img/ringout.wav';

            //set dial distination address  from html input tag
            theCall.destinationAddress = $('#txtRemoteAddress').val();

            //call asynchronous dial method and wait for call CONNECTED event or for other call error (avayaWebRTC.CALL_ERROR_INITIATE_FAILED)
            theCall.dial();

            //call asynchronous call drop method and wait for call DISCONNECTED event or for other call error (avayaWebRTC.CALL_ERROR_DISCONNECT_FAILED)
            theCall.drop();

        @namespace avayaWebRTC
        @class Call
        @constructor
        @param {avayaWebRTC.Client} clientInstance existing avayaWebRTC.Client instance, if invalid, constructor with throw exception.
    **/
    this.Call = function (clientInstance) {
        if (clientInstance === undefined || clientInstance === null) {
            console.log("throw new Error: call constructor should get valid client object instance as parameter");
        }

        clientInstance.log(avayaWebRTC.LOG_INFO, "Call ctor: <--");

        /////////////////////////////////////////////////////////////////////////////
        //private variables
        /**
        Unique call id created locally as a GUID string

        property CallID
        @type {String}
        @private
        **/
        var CallID = ___internals.createUuid();

        /**
        Client context id to be set by the application set property method.
        This property may store information regarding a client interaction so that
        information can be accessed by other applications.
        
        property ContextID
        @type String
        @private
        **/
        var ContextID = "";
        
        /**
        Universal Call ID associated with this call. 
        This UCID uniquely identifies this call within the Avaya Aura environment.
                
        property UCID
        @type String
        @private
        **/
        var UCID = "";

        var that = this;
        var client = clientInstance;
        /**
        Audio Object that is created internally for playing remote party audio

        property remoteAudioTag
        @type {Audio}
        @private
        **/
        var remoteAudioTag = null;
        /**
        STUN List iteration index. When starting a call, a STUN server is referred to based on the STUN priority list supplied by the server.
        The client integrates this list from the 0 index till the end of the list.

        property currentStunIndex
        @type {Number}
        @private
        **/
        var currentStunIndex = 0;

        /**
        When the call is CONNECTED we set this property to true. Thereafter, we follow the peerConnection state.
        If this state becomes DISCONNECTED, we disconnect the call.

        property autoCloseCallOnClosedEvent
        @type {Boolean}
        @private
        **/
        var autoCloseCallOnClosedEvent = false;

        //webrtc variables
        //MediaStream
        /**
        Webrtc MediaStream object that contains local stream to be used as outgoing audio

        property localStream
        @type {MediaStream}
        @private
        **/
        var localStream = null;
        /**
        Webrtc RTCSessionDescription object that contains local session description (SDP)

        property localSessionDescription
        @type {RTCSessionDescription}
        @private
        **/
        var localSessionDescription = null;
        /**
        Webrtc RTCSessionDescription object that contains the local session description (SDP)

        property peerConnection
        @type {RTCPeerConnection}
        @private
        **/
        var peerConnection = null;
        /**
        Webrtc RTCDTMFSender object that is created and used for DTMF functionality

        property peerConnection
        @type {RTCDTMFSender}
        @private
        **/
        var dtmfSender = null;

        /**
        Full SDP including candidates. In case of trickle ICE, sdp is parsed and constructed again when the trickle ICE is completed
        Full sdp including trickle ICE is sent within a single message to server as sdp offer

        property localDescriptionSdpWithCandidates
        @type {String}
        @private
        **/
        var localDescriptionSdpWithCandidates = "";

        /**
        Will gather the trickle ICE list of revealed candidates.
        Only after this list is completed, localDescriptionSdpWithCandidates property will be recomposed.
        In this way the client will be ready for SDP offer.

        property localIceCandidatesLst
        @type {Array}
        @private
        **/
        var localIceCandidatesLst = [];

        /**
        Keeping last requested statistics to allow access to them when call is DISCONNECTED.

        property lastStatistics
        @type {avayaWebRTC.CallStatistics}
        @private
        **/
        var lastStatistics = new avayaWebRTC.CallStatistics();
        //constrains for webrtc - we use only audio in current stage
        if (webrtcDetectedBrowser == CHROMEBROWSER)
        {
        	var mediaConstraints = { 'mandatory' : {
        			'OfferToReceiveAudio': true,
        			'OfferToReceiveVideo': false
        		}
        	};
        }
        else
        {
        	var mediaConstraints = {
    			'OfferToReceiveAudio': true,
    			'OfferToReceiveVideo': false
        	};
        }

        ////////////////////////////////////////////////////////////////////////////
        //web audio api variables for energy level measuring
        var audioEnergyProcessingScript = null;
        var microphone = null;
        var micVolumeLevel = 0.0;
        var micFastVolumeLevel = 0.0;
        var micClipVolumeLevel = 0.0;
        var microphoneLevelsEnabled = false; //to not waste cpu, we will enable only after first request
        //
        /////////////////////////////////////////////////////////////////////////////

        /////////////////////////////////////////////////////////////////////////////
        //public properties
        /**
        Call destination address

        @property destinationAddress
        @type String
        @default ""
        @required
        **/
        this.destinationAddress = "";

        //this.outputAudioFile = "";

        /**
        Full Web URL of the file to play while ringing the remote party.

        @property ringingFileUrl
        @type String
        @default ""
        @optional
        **/
        this.ringingFileUrl = "";

        /////////////////////////////////////////////////////////////////////////////
        // public method for readonly data
        /**
        Unique ID of the call instance

        @property   callID
        @type       String
        @readOnly
        **/
        Object.defineProperty(this, "callID", {
            configurable: true,
            get: function () {
                return CallID;
            }
        });

        /**
        Get/Set context ID of the call

        @property   ContextID
        @type       {String}
        **/
        Object.defineProperty(this, "contextID", {
            configurable: true,
            get: function () {
                return ContextID;
            },
            set: function (val) {
                ContextID = val;
            }
        });
        
        /**
        Gets/Sets UCID of the call. 
        UCID uniquely identifies this call within the Avaya Aura environment.

        @property   UCID
        @type       {String}
        **/
        Object.defineProperty(this, "UCID", {
            configurable: true,
            get: function () {
                return UCID;
            },
            set: function (val) {
                UCID = val;
            }
        });

        /**
        Call instance state. Currently, two states are supported: avayaWebRTC.CALL_STATE_IDLE and avayaWebRTC.CALL_STATE_CONNECTED

        @property   callState
        @type       Number
        @readOnly
        **/
        Object.defineProperty(this, "callState", {
            configurable: true,
            get: function () {
                if (peerConnection === null)
                    return avayaWebRTC.CALL_STATE_IDLE;

                return avayaWebRTC.CALL_STATE_CONNECTED;
            }
        });
        /**
        Call speaker volume. (values from 0 to 1)

        @property   volumeLevel
        @type       Number
        **/
        Object.defineProperty(this, "volumeLevel", {
            configurable: true,
            get: function () {
                if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                    console.log(avayaWebRTC.LOG_ERROR, "Call::getVolumeLevel -- Call is not connected");
                    return 0;
                }

                if (remoteAudioTag)
                    return remoteAudioTag.volume;

                return 0;
            },
            set: function (val) {
                if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                    console.log(avayaWebRTC.LOG_ERROR, "Call::setVolumeLevel -- Call is not connected");
                    return;
                }

                if (val >= 0 && val <= 1 && remoteAudioTag)
                    remoteAudioTag.volume = val;
                else
                    console.log(avayaWebRTC.LOG_ERROR, "Call::setVolumeLevel -- invalid volume value: should be between 0 to 1");
            }
        });

        /**
        Outgoing audio/mic energy level. See the sample code in avayaWebRTC.MicrophoneLevels constructor comments

        @property   microphoneLevels
        @type       avayaWebRTC.MicrophoneLevels
        **/
        Object.defineProperty(this, "microphoneLevels", {
            configurable: true,
            get: function () {
                var level = new avayaWebRTC.MicrophoneLevels();
                if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                    console.log(avayaWebRTC.LOG_ERROR, "Call::microphoneLevels -- Call is not connected");
                    return level; //returned zeros
                }

                if (!that.microphoneLevelsEnabled)
                    that.microphoneLevelsEnabled = true;

                level.localMicVolumeLevel = that.micVolumeLevel;
                level.localFastMicVolumeLevel = that.micFastVolumeLevel;
                level.localMicClippingLevel = that.micClipVolumeLevel;
                return level;
            }
        });
        //
        /////////////////////////////////////////////////////////////////////////////

        /////////////////////////////////////////////////////////////////////////////
        //private methods
        /**
        Subscribes on audio context event to measure outgoing audio energy level

        method connectToAudioEnergySource
        @private
        **/
        var connectToAudioEnergySource = function (stream) {
            console.log(avayaWebRTC.LOG_INFO, 'connectToAudioEnergySource <-->');
            //create context only once
            if (!audioContext)
                audioContext = new AudioContext();

            that.microphone = audioContext.createMediaStreamSource(stream);
            that.audioEnergyProcessingScript = audioContext.createScriptProcessor(2048, 1, 1);
            that.audioEnergyProcessingScript.onaudioprocess = function (event) {
                if (!that.microphoneLevelsEnabled)
                    return;
                var input = event.inputBuffer.getChannelData(0);
                var sum = 0.0;
                var clipcount = 0;
                var index;
                for (index = 0; index < input.length; ++index) {
                    sum += input[index] * input[index];
                    if (Math.abs(input[index]) > 0.99) {
                        clipcount += 1
                    }
                }
                that.micFastVolumeLevel = Math.sqrt(sum / input.length);
                if (isNaN(micVolumeLevel))
                    micVolumeLevel = 0.0;
                that.micVolumeLevel = 0.95 * that.micVolumeLevel + 0.05 * that.micFastVolumeLevel;
                that.micClipVolumeLevel = clipcount / input.length;
            }

            that.microphone.connect(that.audioEnergyProcessingScript);
            that.audioEnergyProcessingScript.connect(audioContext.destination);
        }
        /**
        Unsubscribes from audio context event that measures outgoing audio energy level

        method disconnectAudioEnergySource
        @private
        **/
        var disconnectAudioEnergySource = function () {
            console.log(avayaWebRTC.LOG_INFO, 'disconnectAudioEnergySource <-->');
            if (that.microphone)
                that.microphone.disconnect();
            if (that.audioEnergyProcessingScript)
                that.audioEnergyProcessingScript.disconnect();
        }
        /**
        Validates call instance input when failed call cannot be dialed.

        method validateInput
        @private
        @return {Boolean} is valid or is not valid
        **/
        var validateInput = function (errorCode) {
            var retVal = true;
            var errorDescription = "Call input invalid or not initialized.";
            if (SessionID.trim().length == 0)
                retVal = false;

            //check if destinationAddress is valid
            if (!that.destinationAddress) {
                retVal = false;
            }

            if (!retVal && OnCallErrorCallback)
                OnCallErrorCallback(that, errorCode, avayaWebRTC.CALL_ERROR_REASON_INVALID_INPUT, errorDescription);

            return retVal;
        }
        /**
        Drops the call while keeping certain optional parameters e.g. in some cases we keep localMedia to reconnect the call with next STUN server address in the list.

        method _drop
        @private
        **/
        var _drop = function (excludeLocalMedia, withServerMessage) {
            console.log(avayaWebRTC.LOG_INFO, "Call::_drop -- Closing call resources");

            if (!excludeLocalMedia) {
                autoCloseCallOnClosedEvent = false;
                stopRingingTone();
                localStream = null;
                remoteAudioTag = null;
            }

            disconnectAudioEnergySource();

            dtmfSender = null;
            if (peerConnection && peerConnection.iceConnectionState !== 'closed')
                peerConnection.close();
            peerConnection = null;

            remoteAudioTag = null;
            localSessionDescription = null;
            localDescriptionSdpWithCandidates = "";

            if (withServerMessage) {
                console.log(avayaWebRTC.LOG_INFO, "Call::drop  -- send to server disconnect event");
                serverSocket.emit(CLIENT_MSG_CALL_DISCONNECT, {
                    "sessionid": SessionID,
                    "callid": CallID
                }
                ,
                function (success) {
                    if (!success) {
                        console.log(avayaWebRTC.LOG_ERROR, "Call:drop -- emit(" + CLIENT_MSG_CALL_DISCONNECT + ") failed. Socket error");

                        if (OnCallErrorCallback)
                            OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_DISCONNECT_FAILED, avayaWebRTC.ERR_REASON_SOCKET_ERROR, "Failed to hang up. Socket error.");
                    }
                }
                );
            }
        }
        
        var _getUserMediaSuccess = function (stream) {
                localStream = stream;
                remoteAudioTag = new Audio();

                var audioTracks = localStream.getAudioTracks();
                if (audioTracks.length > 0) {
                    console.log(avayaWebRTC.LOG_INFO, 'Using Audio device: ' + audioTracks[0].label);
                }

                startRingingTone(that.ringingFileUrl);

                _initiate(true);

                //closure method _initiate is called to dial using specific stun in priority list.
                function _initiate(isFirstTime) {
                    autoCloseCallOnClosedEvent = false;
                    if (!isFirstTime && currentStunIndex >= STUNAddresses.length) {
                        _drop(false, false);
                        console.log(avayaWebRTC.LOG_ERROR, "Client:initiate -- stuns list is over. No stuns more to try to connect.");

                        if (OnCallErrorCallback)
                            OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.ERR_REASON_STUN_ERROR, "Failed to dial. No network identification for this client using supplies by configuration STUN servers.");
                        return;
                    }


                    console.log(avayaWebRTC.LOG_INFO, "create peer connection to obtain all the candidates");
                    var fullStunAddress = "";
                    var servers = [];

                    if (currentStunIndex < STUNAddresses.length) {
                        fullStunAddress = STUNAddresses[currentStunIndex].ServerAddress;
                        if (STUNAddresses[currentStunIndex].ServerPort > 0)
                            fullStunAddress = fullStunAddress + ':' + STUNAddresses[currentStunIndex].ServerPort + '';

                        servers.push({ url: 'stun:' + fullStunAddress });
                    }
                    else
                    {
                        //configure without STUN
                    }

                    var pc_config = { 'iceServers': servers };
                    peerConnection = new RTCPeerConnection(pc_config, { 'mandatory': {'googIPv6': false}, 
                    	"optional": [/*{ "DtlsSrtpKeyAgreement": true}*/] });
                    var currentCallData = getCallData(CallID);
                    currentCallData.peerConnection = peerConnection; //keep it to be accessed by client object

                    peerConnection.onaddstream = onAddStream;
                    peerConnection.onremovestream = onRemoveStream;
                    if (typeof peerConnection.oniceconnectionstatechange !== 'undefined') {
                        peerConnection.oniceconnectionstatechange = onIceConnectionStateChange;
                    }
                    else {
                        peerConnection.onicechange = onIceConnectionStateChange;
                    }

                    if (typeof peerConnection.onsignalingstatechange !== 'undefined') {
                        peerConnection.onsignalingstatechange = onChangeState;
                    }
                    else {
                        peerConnection.onstatechange = onChangeState;
                    }

                    console.log(avayaWebRTC.LOG_INFO, "Call::initiate  -- Add local stream to peer connection");
                    peerConnection.addStream(localStream);

                    function onAddStream(event) {
                        console.log(avayaWebRTC.LOG_INFO, "Call::onAddStream <-->.");
                        if (remoteAudioTag) {
                            remoteAudioTag.autoplay = true;
                            attachMediaStream(remoteAudioTag, event.stream);
                        }

                        var audioTracks = localStream.getAudioTracks();
                        if (audioTracks.length > 0 && peerConnection.createDTMFSender) {
                            console.log(avayaWebRTC.LOG_INFO, "Call::onAddStream: create dtmf sender object");
                            dtmfSender = peerConnection.createDTMFSender(audioTracks[0]);
                            dtmfSender.ontonechange = dtmfOnToneChange;
                            console.log(avayaWebRTC.LOG_INFO, "Call::onAddStream: dtmf sender created");
                        }

                        connectToAudioEnergySource(localStream);

                    }
                    //closure callback fired by dtmf sender to notify that specific tone is sent
                    function dtmfOnToneChange(tone) {
                        console.log(avayaWebRTC.LOG_INFO, "Call::dtmfOnToneChange <-->. Sent dtmf tone: " + tone.tone);
                    }
                    //closure callback fired by peerconnection to notify that media stream is removed
                    function onRemoveStream(event) {
                        console.log(avayaWebRTC.LOG_INFO, "Call::onRemoveStream <-->.");
                        if (remoteAudioTag)
                            detachMediaStream(remoteAudioTag);
                    }
                    //closure callback fired by peerconnection to notify that ice connection state has been changes
                    function onIceConnectionStateChange() {
                        console.log(avayaWebRTC.LOG_INFO, "Call::onIceConnectionStateChange <-->.");
                        var iceState;
                        if (peerConnection) {
                            iceState = peerConnection.iceConnectionState;
                            console.log(avayaWebRTC.LOG_INFO, "Call::onIceConnectionStateChange: -- PeerConnection ICE connection state change callback, state:" + iceState);
                            if (autoCloseCallOnClosedEvent && (iceState === 'disconnected' || iceState === 'closed')) {
                                console.log(avayaWebRTC.LOG_INFO, "Call::onIceConnectionStateChange: -- Force call drop. Peer Connection possibly interrupted");
                                that.drop();
                            }

                            if (iceState === 'failed') {
                                if (autoCloseCallOnClosedEvent) {
                                    console.log(avayaWebRTC.LOG_INFO, "Call::onIceConnectionStateChange: -- drop call on peer connection ice failure.");
                                    that.drop();
                                }
                                else if (webrtcDetectedBrowser !== CHROMEBROWSER) {
                                    //found the following behavior in firefox: if stun cannot be connected, ice state is failed and we will restart _initiate with next stun in list.
                                    //in chrome, observed following: in such case, on ice candidate callback is launched forever so we threat it there.

                                    //in such case warn and retry with next stun
                                    if (currentStunIndex < STUNAddresses.length) {
                                        var fullStunAddress = STUNAddresses[currentStunIndex].ServerAddress;
                                        if (STUNAddresses[currentStunIndex].ServerPort > 0)
                                            fullStunAddress = fullStunAddress + ':' + STUNAddresses[currentStunIndex].ServerPort + '';
                                        console.log(avayaWebRTC.LOG_WARN, "Call::onIceConnectionStateChange: -- reset peer connection ice failure. STUN: " + fullStunAddress + " did not answer. Restarting peer connection with next stun in list.");
                                    }
                                    _drop(true, false);
                                    currentStunIndex++;
                                    _initiate();
                                }
                            }
                        }
                    }
                    //closure callback fired by peerconnection to notify that signalling connection state has been changes
                    function onChangeState() {
                        console.log(avayaWebRTC.LOG_INFO, "Call::onChangeState <-->.");
                        var state;
                        if (peerConnection) {
                            state = peerConnection.signalingState || peerConnection.readyState;
                            console.log(avayaWebRTC.LOG_INFO, "Call::onChangeState: Peer connection signalling state changed callback, state:" + state);
                            if (autoCloseCallOnClosedEvent && (state === 'closed' || state === 'disconnected')) {
                                console.log(avayaWebRTC.LOG_INFO, "Call::onChangeState: -- Force call drop. Peer Connection possibly interrupted");
                                that.drop();
                            }
                        }
                    }
                    //closure callback fired by peerconnection to notify about new ice candidates trickle or about end of candidates list
                    function OnIceCandidateCB(event) {
                        if (event.candidate) {
                            localIceCandidatesLst.push(event.candidate);
                            return;
                        } else {
                            if (webrtcDetectedBrowser === CHROMEBROWSER || 
                            		(webrtcDetectedBrowser === FIREFOXBROWSER && webrtcDetectedVersion > 33)) {
                                if (localIceCandidatesLst.length == 0) {
                                    //found the following behavior in firefox: if stun cannot be connected, ice state is failed and we will restart _initiate with next stun in list.
                                    //in chrome, observed following: in such case, on ice candidate callback is launched forever so we threat it there.

                                    //in such case warn and retry with next stun
                                    if (currentStunIndex < STUNAddresses.length) {
                                        var fullStunAddress = STUNAddresses[currentStunIndex].ServerAddress;
                                        if (STUNAddresses[currentStunIndex].ServerPort > 0)
                                            fullStunAddress = fullStunAddress + ':' + STUNAddresses[currentStunIndex].ServerPort + '';
                                        console.log(avayaWebRTC.LOG_WARN, "Call::OnIceCandidate: -- reset peer connection when no candidates found. STUN: " + fullStunAddress + " did not answer. Restarting peer connection with next stun in list.");
                                    }
                                    _drop(true, false);
                                    currentStunIndex++;
                                    return _initiate();
                                }

                                localDescriptionSdpWithCandidates = peerConnection.localDescription.sdp;

                                if (webrtcDetectedBrowser === CHROMEBROWSER) {
                                
                                    //fix trickle behaviour - add candidates to sdp like in firefox
                                    $.each(localIceCandidatesLst, function (index, value) {
                                        console.log(avayaWebRTC.LOG_INFO, "Call::initiate -- Candidate " + value.sdpMLineIndex + " - " + value.sdpMid + ': ' + value.candidate);
                                        var candidateValue = value.candidate;
                                        var finalCandidateValue;
                                        if (candidateValue.substring (0,2) == "a=") {
                                            finalCandidateValue = candidateValue;
                                        } else {
                                            finalCandidateValue = "a=" + candidateValue;
                                        }

                                        console.log(avayaWebRTC.LOG_INFO, "Call::initiate -- final Candidate " + value.sdpMLineIndex + " - " + value.sdpMid + ': ' + value.candidate);
                                     
                                        ___internals.addIceCandidateToSDP(localDescriptionSdpWithCandidates, value.sdpMid, finalCandidateValue,
                                                function (resultSdp) {
                                                    localDescriptionSdpWithCandidates = resultSdp;
                                                },
                                                function (message) {
                                                    console.log(avayaWebRTC.LOG_ERROR, "Call::initiate -- Internal parsing error. Failed to add candidate to sdp. " + message);
                                                });
                                    });
                                }
                                                            
                                console.log(avayaWebRTC.LOG_INFO, "Call:initiate: Get the IP and Port from candidates in sdp");
                                ___internals.updateCLineIPAndMLinePort(localDescriptionSdpWithCandidates,
                                        function (resultSdp) {
                                            localDescriptionSdpWithCandidates = resultSdp;
                                        },
                                        function (message) {
                                            console.log(avayaWebRTC.LOG_ERROR, "Call::initiate -- Internal parsing error. Failed order audio codecs priority. " + message);
                                        });
                                        
                                console.log(avayaWebRTC.LOG_INFO, "Call::initiate  Full Ready sdp: " + localDescriptionSdpWithCandidates);
                                localIceCandidatesLst.splice(0, localIceCandidatesLst.length);
                            }
                        }                           

                        autoCloseCallOnClosedEvent = true; //let peer connection states interrupt the call if needed

                        //send dialing state callback to allow call dropping from now
                        if (OnCallInitiatingCallback) {
                            OnCallInitiatingCallback(that);
                        }

                        //start sdp offer from here
                        //invoke socket message
                        serverSocket.emit(CLIENT_MSG_CALL_SDP_OFFER, {
                            "sessionid": SessionID,
                            "contextid": that.ContextID,
                            "callid": CallID,
                            "destinationaddress": that.destinationAddress,
                            "sdpoffer": localDescriptionSdpWithCandidates
                        }
                    ,
                    function (success) {
                        if (!success) {
                            _drop(false, false);
                            console.log(avayaWebRTC.LOG_ERROR, "Call:initiate -- emit(" + CLIENT_MSG_CALL_SDP_OFFER + ") failed. Socket error");

                            if (OnCallErrorCallback)
                                OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.ERR_REASON_SOCKET_ERROR, "Failed to dial. Socket error.");
                        }
                    }
                    );

                        console.log(avayaWebRTC.LOG_INFO, "Call::initiate  -->");
                    }

                    peerConnection.onicecandidate = OnIceCandidateCB;

                    console.log(avayaWebRTC.LOG_INFO, "Call::initiate  -- Create peer connection offer");
                    peerConnection.createOffer(function (desc) {
                        console.log(avayaWebRTC.LOG_INFO, "Call::initiate  -- Create local session description");
                        localDescriptionSdpWithCandidates = desc.sdp;
                        localSessionDescription = new RTCSessionDescription({ type: 'offer', sdp: desc.sdp });
                        console.log(avayaWebRTC.LOG_INFO, "Call::initiate  -- Set local session description to peer connection");

                        peerConnection.setLocalDescription(localSessionDescription,
                          function () {
                              console.log(avayaWebRTC.LOG_INFO, "Call::initiate  -- set local peer connection session description succeeded");
                          },
                          function (error) {
                              _drop(false, false);

                              if (OnCallErrorCallback)
                                  OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.CALL_ERROR_REASON_PEER_CONNECTION_LOCAL_DESCRIPTION_FAILED, 'Failed to set local peer connection session description');
                              console.log(avayaWebRTC.LOG_ERROR, "Call::initiate  -- Failed to set local peer connection session description");
                          });
                    },
                      function (error) {
                          _drop(false, false);
                          if (OnCallErrorCallback)
                              OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.CALL_ERROR_REASON_PEER_CONNECTION_CREATE_OFFER_FAILED, 'Failed to create peer connection offer: [' + error.message + ']');
                          console.log(avayaWebRTC.LOG_ERROR, "Call::initiate  -- Failed to create peer connection offer: [" + error.message + ']');
                      },
                      mediaConstraints);
                }        	
        }
        //
        /////////////////////////////////////////////////////////////////////////////

        /////////////////////////////////////////////////////////////////////////////
        //public methods
        /**
        Establishes a call. The method is asynchronous.
        Web application should listen for relevant events.
        See the comments of this class constructor for code sample.

        @method initiate
        @async

        **/
        this.initiate = function () {
            console.info(avayaWebRTC.LOG_INFO, "Call::initiate <--");
            if (this.callState !== avayaWebRTC.CALL_STATE_IDLE) {
                console.log(avayaWebRTC.LOG_ERROR, "Call::initiate -- Call is already connected");
                if (OnCallErrorCallback)
                    OnCallErrorCallback(this, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.CALL_ERROR_REASON_CLIENT_NOT_CONNECTED, "Call is already connected.");
                return;
            }

            //first, validate input
            if (!validateInput(avayaWebRTC.CALL_ERROR_INITIATE_FAILED)) {
                return;
            }

            if (!client.isConnected) {
                if (OnCallErrorCallback)
                    OnCallErrorCallback(this, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.CALL_ERROR_REASON_CLIENT_NOT_CONNECTED, "Client is disconnected.");
                return;
            }

            currentStunIndex = 0; //start stun load balancing

            console.log(avayaWebRTC.LOG_INFO, "Call::initiate -- obtain user permission to use media devices");
            //closure callback getUserMediaSuccess is called when user allowed by clicking allow button to avayaWebRTC to use audio input device (mic)
            
            if (webrtcDetectedBrowser === FIREFOXBROWSER){
            		getMediaDevices.getUserMedia({ audio: true, video: false }).then (function (stream) {
            			_getUserMediaSuccess(stream);
            		}).catch (function getUserMediaFailure(err) {
            			_drop(false, false);
                        if (OnCallErrorCallback) {
                        	OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.CALL_ERROR_REASON_GET_MEDIA_FAILURE, 'Error while requiring user media. ' + error.name + " " + error.message);
                        }
                        console.log(avayaWebRTC.LOG_ERROR, "Call::initiate -- getUserMedia error [" + err.name + " " + err.message + '].');                        
             		})	
            } else {
            	getUserMedia({ audio: true, video: false }, getUserMediaSuccess, getUserMediaFailure);
                //closure callback getUserMediaSuccess is called when user allowed by clicking allow button to avayaWebRTC to use audio input device (mic)
                function getUserMediaSuccess(stream) {
                	_getUserMediaSuccess(stream);
                }
                //closure callback getUserMediaFailure is called when user denied by clicking deny button to avayaWebRTC to use audio input device (mic)
                function getUserMediaFailure(error) {
                	console.log(avayaWebRTC.LOG_ERROR, "Call::initiate -- getUserMediaFailure error, try with mediaDevices [" + error.name + " " + error.message + '].');
                	navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then (function (stream) {
            			_getUserMediaSuccess(stream);
            		}).catch (function getUserMediaFailure(err) {
            			//closure callback getUserMediaFailure is called when user denied by clicking deny button to avayaWebRTC to use audio input device (mic)                
            			_drop(false, false);
            			if (OnCallErrorCallback) {
            				OnCallErrorCallback(that, avayaWebRTC.CALL_ERROR_INITIATE_FAILED, avayaWebRTC.CALL_ERROR_REASON_GET_MEDIA_FAILURE, 'Error while requiring user media. ' + error.name + " " + error.message);
            			}
                		console.log(avayaWebRTC.LOG_ERROR, "Call::initiate -- getUserMedia error [" + err.name + " " + err.message + '].');
             		})
                }
            }
        }
        /**
        Drops a call. The method is asynchronous. Web application should listen for relevant events. See the comments of this class constructor for code sample.

        @method drop
        @async

        **/
        this.drop = function () {
            console.log(avayaWebRTC.LOG_INFO, "Call::drop <--");
            if (this.callState === avayaWebRTC.CALL_STATE_IDLE) {
                console.log(avayaWebRTC.LOG_ERROR, "Call::drop -- Call is not connected");
                return;
            }

            _drop(false, true);

            console.log(avayaWebRTC.LOG_INFO, "Call::drop  -->");
        }
        
        this.getStatisticsFireFox = function (onReadyCallback) {
            peerConnection.getStats(null,
                function (stats) {
                    var newStats = new avayaWebRTC.CallStatistics();
                    var foundInbound = 0;
                    var foundOutbound = 0;
                        for(key in stats)
                        {
                            var res = stats[key];
                            if(res.type=='inboundrtp' && foundInbound == 0)
                            {
                                newStats.remoteAudioBytesReceived = res.bytesReceived;
                                newStats.remoteAudioPacketsReceived = res.packetsReceived;
                                newStats.remoteAudioPacketsLost = res.packetsLost;
                                newStats.remoteAudioJitterReceived = Number(res.jitter)*1000;
                                foundInbound = 1;
                            }
                            if(res.type=='outboundrtp' && foundOutbound == 0)
                            {
                                newStats.localAudioPacketsSent = res.packetsSent;
                                newStats.localAudioBytesSent = res.bytesSent;
                                foundOutbound = 1;
                            }
                            if(foundOutbound == 1 && foundInbound == 1)
                            {
                                break;
                            }
                        }
                    lastStatistics = newStats;
                    if (onReadyCallback != undefined && onReadyCallback) {
                        onReadyCallback(newStats);
                    }
                },
                function (error) {

                }
            );
        }  
        
        this.getStatisticsChrome = function (onReadyCallback) {
        	 peerConnection.getStats(
                     function (stats) {
                         var newStats = new avayaWebRTC.CallStatistics();
                         var arrayOfRawStats = stats.result();
                         if (arrayOfRawStats) {
                             try {
                                 //convert from raw statistics to values
                                 for (var arrayIndex = 0; arrayIndex < arrayOfRawStats.length; arrayIndex++) {
                                     var currentResult = arrayOfRawStats[arrayIndex];
                                     if (currentResult.type == 'ssrc') {
                                         var entriesNames = currentResult.names();
                                         if (entriesNames.indexOf('audioInputLevel') >= 0 || entriesNames.indexOf('packetsSent') >= 0 || entriesNames.indexOf('bytesSent') >= 0) {
                                             //local
                                             if (entriesNames.indexOf("audioInputLevel") >= 0)
                                                 newStats.localAudioInputLevel = currentResult.stat("audioInputLevel");
                                             if (entriesNames.indexOf("googCodecName") >= 0)
                                                 newStats.localAudioCodecName = currentResult.stat("googCodecName");
                                             if (entriesNames.indexOf("googJitterReceived") >= 0)
                                                 newStats.localAudioJitterReceived = currentResult.stat("googJitterReceived");
                                             if (entriesNames.indexOf("packetsSent") >= 0)
                                                 newStats.localAudioPacketsSent = currentResult.stat("packetsSent");
                                             if (entriesNames.indexOf("bytesSent") >= 0)
                                                 newStats.localAudioBytesSent = currentResult.stat("bytesSent");
                                         }
                                         else {
                                             //remote
                                             if (entriesNames.indexOf("bytesReceived") >= 0)
                                                 newStats.remoteAudioBytesReceived = currentResult.stat("bytesReceived");
                                             if (entriesNames.indexOf("packetsLost") >= 0)
                                                 newStats.remoteAudioPacketsLost = currentResult.stat("packetsLost");
                                             if (entriesNames.indexOf("packetsReceived") >= 0)
                                                 newStats.remoteAudioPacketsReceived = currentResult.stat("packetsReceived");
                                             if (entriesNames.indexOf("audioOutputLevel") >= 0)
                                                 newStats.remoteAudioOutputLevel = currentResult.stat("audioOutputLevel");
                                             if (entriesNames.indexOf("googJitterReceived") >= 0)
                                                 newStats.remoteAudioJitterReceived = currentResult.stat("googJitterReceived");
                                         }
                                     }
                                 }
                             }
                             catch (e) {
                                 console.log(avayaWebRTC.LOG_ERROR, "Call::getStatistics -- statistics result parsing failed.");
                             }
                         }
                         lastStatistics = newStats;
                         if (onReadyCallback != undefined && onReadyCallback) {
                             onReadyCallback(newStats);
                         }
                     },
                     function (error) {

                     }
                 );
        }
        /**
        Returns call statistics. See the example in the avayaWebRTC.CallStatistics class constructor comments.
        Supported in Chrome and firefox browser only.

        @method getStatistics
        @param  {callback} onReadyCallback Callback that will be called to provide avayaWebRTC.CallStatistics instance with statistics
        **/
        this.getStatistics = function (onReadyCallback, stream) {
            console.log(avayaWebRTC.LOG_INFO, "Call::GetStatistics <--");
            if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                console.log(avayaWebRTC.LOG_ERROR, "Call::getStatistics -- Call is not connected");
                return;
            }

            if (webrtcDetectedBrowser !== CHROMEBROWSER && webrtcDetectedBrowser !== FIREFOXBROWSER) {
                if (onReadyCallback) {
                    onReadyCallback(new avayaWebRTC.CallStatistics());
                }
                return;
            }
            if (webrtcDetectedBrowser == CHROMEBROWSER)
            {
                this.getStatisticsChrome(onReadyCallback);
            }
            else
            {
                this.getStatisticsFireFox(onReadyCallback);
            }

            console.log(avayaWebRTC.LOG_INFO, "Call::GetStatistics  -->");
        }
        /**
        Sends a DTMF character(s). Supported in Chrome browser only.

        @method sendDTMF
        @param  {String} tones DTMF character(s) from 0 to 9 and from A to D
        **/
        this.sendDTMF = function (tones) {
            console.log(avayaWebRTC.LOG_INFO, "Call::sendDTMF <--");
            if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                console.log(avayaWebRTC.LOG_ERROR, "Call::sendDTMF -- Call is not connected");
                return;
            }

            if (dtmfSender) {
                dtmfSender.insertDTMF(tones);
            }

            console.log(avayaWebRTC.LOG_INFO, "Call::sendDTMF  -->");
        }
        /**
        Mutes outgoing audio channel

        @method mute
        **/
        this.mute = function () {
            console.log(avayaWebRTC.LOG_INFO, "Call::mute <--");
            if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                console.log(avayaWebRTC.LOG_ERROR, "Call::mute -- Call is not connected");
                return;
            }

            if (localStream) {
                var audioTracks = localStream.getAudioTracks();
                if (audioTracks.length > 0) {
                    audioTracks[0].enabled = false;
                }
            }

            console.log(avayaWebRTC.LOG_INFO, "Call::mute  -->");
        }
        /**
        Unmutes outgoing audio channel

        @method unmute
        **/
        this.unmute = function () {
            console.log(avayaWebRTC.LOG_INFO, "Call::unmute <--");
            if (this.callState !== avayaWebRTC.CALL_STATE_CONNECTED) {
                console.log(avayaWebRTC.LOG_ERROR, "Call::unmute -- Call is not connected");
                return;
            }

            if (localStream) {
                var audioTracks = localStream.getAudioTracks();
                if (audioTracks.length > 0) {
                    audioTracks[0].enabled = true;
                }
            }

            console.log(avayaWebRTC.LOG_INFO, "Call::unmute  -->");
        }
        /**
        Destroys call instance

        @method destroy
        **/
        this.destroy = function () {
            console.log(avayaWebRTC.LOG_INFO, "Call::destroy <- Call Id=" + CallID);

            var foundCalls = $.grep(callsCollection, function (calldata) {
                return (calldata.call.callID === CallID);
            });

            if (foundCalls.length > 0) {
                callsCollection = $.grep(callsCollection, function (calldata) {
                    return !(calldata.call.callID === CallID);
                });

            }
            else {
                console.log(avayaWebRTC.LOG_ERROR, "Call::destroy -> Call Id " + CallID + " Not found.");
                return;
            }
            console.log(avayaWebRTC.LOG_INFO, "Call::destroy -> ");
        }
        //
        /////////////////////////////////////////////////////////////////////////////

        //add call to avayaWebRTC namespace calls collection
        callsCollection.push({ "call": this, "peerConnection": null, "_drop": _drop});

        console.info(avayaWebRTC.LOG_INFO, "Call ctor: -->");
    }
// End of avayaWebRTC
////////////////////////////////////////////////////////////////////////////////////////////////////////////

}
// End of avayaWebRTC namespace
////////////////////////////////////////////////////////////////////////////////////////////////////////////
module.exports.avayaWebRTC = avayaWebRTC;
/**********************************************************************************************************/
//internal utils
/**********************************************************************************************************/
function getScriptBasicUrl(scriptName) {
    var scriptElements = document.getElementsByTagName('script');
    var counter, element, myfile;
    var scriptsBasicUrl = "";
    for (counter = 0; element = scriptElements[counter]; counter++) {
        myfile = element.src;
        if (myfile.indexOf(scriptName) >= 0) {
            scriptsBasicUrl = myfile.substring(0, myfile.indexOf(scriptName));
            break;
        }
    }
    return scriptsBasicUrl;
}


// WEBPACK FOOTER //
// ./src/call/avayawebrtc-client.js